var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',[_c('v-flex',{attrs:{"xs12":"","lg10":"","offset-lg1":""}},[(_vm.$store.state.usuario.type == 'Comercial')?_c('v-flex',[_c('cabeceraPedido')],1):_vm._e(),(_vm.windowSize.x > 960)?_c('Pedido'):_vm._e(),(_vm.windowSize.x <= 960)?_c('PedidoMobile'):_vm._e()],1),_c('dialogTipoCobro')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }